// extracted by mini-css-extract-plugin
export var fadeInOut = "_2r-3";
export var icon = "_2r-4";
export var savedIndicator = "_2r-2";
export var savingIndicator = "_2r-0";
export var spin = "_2r-1";